import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Box, Card, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Controller } from "react-hook-form";
import {
  StyledTextField,
  StyledTextFieldBootstrap,
} from "../../doctor-console/StyledComponents";
import CareContextCreationNonAbdm from "./CareContextCreationNonAbdm";

const CreateCareContext = ({ abhaId, handleClose }) => {
  const [patientList, setPatientList] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showDemographic, setShowDemographic] = useState(false);
  const [showSubmit, setShowSubmit] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    control,
    getValues,
    setValue,
    watch,
    reset,
  } = useForm();

  const {
    register: register1,
    handleSubmit: handleSubmit1,
    formState: { errors: errors1 },
    setError: setError1,
    getValues: getValues1,
    setValue: setValue1,
    reset: reset1,
  } = useForm();

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    setError: setError2,
    getValues: getValues2,
    setValue: setValue2,
    reset: reset2,
  } = useForm();

  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const resetForm = () => {
    reset();
    reset1();
    reset2();
    setShowDemographic(false);
    setShowSubmit(false);
  };
  useEffect(() => {
    if (authToken !== "") {
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
          {
            headers: headers,
          }
        )
        .then((res) => {
          setPatientList(res.data?.data);
        });
    }
  }, [authToken]);

  const findPatient = (data) => {
    const foundPatient = patientList.find(
      (patient) => patient.patient_id === data.patient_id
    );
    if (foundPatient) {
      setShowDemographic(true);
      setSelectedPatient(foundPatient);
      setValue1("name", foundPatient.name);
      setValue1("gender", foundPatient.gender);
      setValue1("age", foundPatient.age);
      setValue1("phoneNo", foundPatient.phone_no);
      console.log("Patient found", foundPatient);
    } else {
      console.log("Patient not found");
    }
  };
  const next = () => {
    setShowSubmit(true);
  };
  // useEffect(() => {
  //   if (abhaId && patientList.length > 0) {
  //     const foundPatient = patientList.find(
  //       (patient) => patient.abha_id === abhaId
  //     );
  //     if (foundPatient) {
  //       console.log("found patient",foundPatient)
  //       setSelectedPatient(foundPatient.patient_id);
  //       setValue("patient_id", foundPatient.patient_id);
  //     }
  //   }
  // }, [abhaId,patientList]);
  useEffect(() => {
    if (abhaId && patientList.length > 0) {
      const foundPatient = patientList.find(
        (patient) => patient.abha_id === abhaId
      );
      if (foundPatient) {
        console.log("found patient", foundPatient);
        setSelectedPatient(foundPatient);
        setValue("patient_id", foundPatient.patient_id);
      }
    }
  }, [abhaId, patientList, setValue]);

  const patientId = watch("patient_id");

  const AddCareContext = () => {
    const reqBody = {
      patient_id: getValues("patient_id"),
      visit_details: getValues2("visit_details"),
    };
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}create_care_context/`,
        JSON.stringify(reqBody),
        {
          headers: headers,
        }
      )
      .then((res) => {
        if (res.data.status == "Success") {
          toast.success(
            `Visit Purpose Reference Id "${res.data.ref_num}"This ID will be used for linking to ABDM.`
          );
          resetForm();
          handleClose();
        } else {
          toast.error("some error occurred");
        }

        console.log("Add Visit Purpose", res.data);
      })
      .catch((err) => {
        console.log(err);
        toast.error(err);
      });
  };
  console.log("selected patid", selectedPatient);

  return (
    <>
      {/* <Modal open={open} onClose={handleClose} style={{ overflowY: "auto" }}> */}
      <Box
        sx={{
          //   position: "absolute",
          //   top: "50%",
          //   left: "50%",
          //   transform: "translate(-50%, -50%)",
          width: { xs: "80%", sm: "60%", md: "60%" },
          maxWidth: "900px",
          //   maxHeight: "90vh",
          overflowY: "auto",
          px: 0,
          py: { xs: 2, sm: 3 },
          background: "transparent",
          boxShadow: "none",
          border: "none",
          margin: "auto",
          mb: 2,
        }}
      >
          <Card
            sx={{
              backgroundColor: "#FDFDFD",
              borderRadius: "12px",
              width: "100%",
              p: 0,
              border: "1px solid #E5E7EB",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.08)",
            }}
          >
            {/* Header bar (consistent design) */}
            <Box
              sx={{
                backgroundColor: "#213360",
                color: "#FFFFFF",
                px: "24px",
                // py: "28px",
                minHeight: "72px",
                display: "flex",
                alignItems: "center",
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                borderBottom: "1px solid rgba(255,255,255,0.15)",
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 500, color: "#FFFFFF", fontSize: "24px" }}>
                Create Visit Purpose
              </Typography>
            </Box>
            <CareContextCreationNonAbdm
              abhaId={abhaId}
              handleClose={handleClose}
            />
          </Card>
      </Box>
      {/* </Modal> */}
    </>
  );
};

export default CreateCareContext;
